// extracted by mini-css-extract-plugin
export default {"time":"Time_time__IQ3at","text":"Time_text__3QaNg","icon":"Time_icon__KFuV+"};